import { ActionTree } from 'vuex'
import { RootState } from '../types'
import { NavigationMutations } from './mutations'
import { NavigationState, SetAlertSidebarRequest } from './types'

export const actions: ActionTree<NavigationState, RootState> = {
  setActiveMenuItem({ commit }, payload: number) {
    commit(NavigationMutations.SET_ACTIVE_MENU, payload)
  },

  setSidebarExpanded({ commit }, payload: boolean) {
    commit(NavigationMutations.SET_EXPANDED_MENU, payload)
  },

  setHideSidebar({ commit }, payload: boolean) {
    commit(NavigationMutations.SET_HIDE_SIDEBAR, payload)
  },

  setLoadingPage({ commit }, payload: boolean) {
    commit(NavigationMutations.SET_LOADING_PAGE, payload)
  },
  setAlertSidebar({ commit }, payload: SetAlertSidebarRequest) {
    commit(NavigationMutations.SET_ALERT_SIDEBAR, payload)
  }
}
